type ValidatorFn = (value: string) => boolean

export const getPasswordStrength = <T extends string>(
  password: string,
  rulesMap: { [P in T]: RegExp | ValidatorFn }
): { [P in T]: boolean } =>
  Object.keys(rulesMap).reduce(
    (acc, ruleName) => {
      const fnOrPattern: RegExp | ValidatorFn = rulesMap[ruleName as T]

      return {
        ...acc,
        [ruleName]:
          typeof fnOrPattern === 'function'
            ? fnOrPattern(password)
            : fnOrPattern.test(password),
      }
    },
    {} as { [P in T]: boolean }
  )
